export function frontendBuildSha() {
  return String(process.env.VUE_APP_BUILD_SHA || "").trim();
}

function checkoutVersionUrl() {
  const basePath = String(process.env.BASE_URL || "/app/").replace(/\/?$/, "/");
  return `${basePath}version.json?ts=${Date.now()}`;
}

export function checkoutReloadAttempted(reloadKey) {
  try {
    return window.sessionStorage?.getItem(reloadKey) === "1";
  } catch (_error) {
    return false;
  }
}

export function markCheckoutReloadAttempt(reloadKey) {
  try {
    if (!window.sessionStorage) {
      return false;
    }
    window.sessionStorage.setItem(reloadKey, "1");
    return window.sessionStorage.getItem(reloadKey) === "1";
  } catch (_error) {
    return false;
  }
}

export async function checkCheckoutFrontendFreshness({
  onReload = null,
  onStale = null,
  timeoutMs = 2500,
} = {}) {
  const currentSha = frontendBuildSha();
  if (
    !currentSha ||
    typeof window === "undefined" ||
    typeof window.fetch !== "function"
  ) {
    // Local/dev builds do not always carry release metadata; skip the
    // freshness check unless the deployed build SHA was injected.
    return true;
  }

  try {
    const fetchOptions = {
      cache: "no-store",
      credentials: "same-origin",
      headers: { "Cache-Control": "no-cache" },
    };
    const controller = typeof AbortController !== "undefined"
      ? new AbortController()
      : null;
    let timeoutId = null;
    if (controller) {
      fetchOptions.signal = controller.signal;
      timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);
    }

    let response = null;
    try {
      response = await window.fetch(checkoutVersionUrl(), fetchOptions);
    } finally {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    }
    if (!response.ok) {
      return true;
    }

    const liveVersion = await response.json();
    const liveSha = String(liveVersion.commit_sha || "").trim();
    if (!liveSha || liveSha === currentSha) {
      return true;
    }

    const reloadKey = `invown_checkout_v2_reloaded_${liveSha}`;
    if (checkoutReloadAttempted(reloadKey)) {
      if (onStale) {
        onStale();
      }
      return true;
    }

    if (!markCheckoutReloadAttempt(reloadKey)) {
      if (onStale) {
        onStale();
      }
      return true;
    }

    if (onReload) {
      onReload();
      return false;
    }

    return true;
  } catch (_error) {
    return true;
  }
}
